import classnames from "classnames";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { formatRoute } from "react-router-named-routes";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CustomBreadcrumb from "../../../Components/CustomBreadcrumb";
import { activeMenuTab } from "../../../Store/Actions/User";
import constants from "../../../Utils/constants";
import DocumentTitle from "../../../Utils/DocumentTitle";
import ListMetrics from "./ListMetrics";
import ListMetricTypes from "./ListMetricTypes";
import ListMetricsUnit from "./ListMetricsUnit";

class ListMetricTypesAndMetrics extends Component {
  state = {
    totalTabs: [],
    selectedTab: constants.APPLICATION_ROUTE.MANAGE_METRIC_TYPE_AND_DATA.TABS[0].KEY,
  };

  // Handler to update the selected tab state when tab content changes
  onContentChangeTypeHandler = s => {
    this.setState({
      selectedTab: s,
    });
  };

  // Function to return breadcrumb structure for navigation hierarchy
  breadcrumbs = () => {
    let breadcrumbs = [
      {
        title: constants.APPLICATION_ROUTE.MASTER_DATA_GROUP.NAME, // Parent breadcrumb
        link: null,
        is_active: false,
      },
      {
        title: constants.APPLICATION_ROUTE.MANAGE_METRIC_TYPE_AND_DATA.NAME, // Current page breadcrumb
        link: null,
        is_active: true,
      },
    ];
    return breadcrumbs;
  };

  // Lifecycle method: Executes when component mounts
  componentDidMount() {
    // Parse query parameters from URL
    let params = queryString.parse(this.props.location.search);

    // Get tabs from constants and remove hidden ones
    let tabs = constants.APPLICATION_ROUTE.MANAGE_METRIC_TYPE_AND_DATA.TABS;
    tabs = tabs.filter(tab => tab.HIDE_TAB === false);

    // Initialize tab and role-related states based on URL or default to the first tab
    this.setState({
      totalTabs: tabs,
      selectedTab: params.selected_tab ? params.selected_tab : tabs[0].KEY,
      modifiedValueType: params.state ? params.state : tabs[0].STATE,
      modifiedValueRole: params.role ? params.role : tabs[0].ROLE,
    });

    // Notify parent or global state about the active tab for menu UI
    this.props.activeMenuTab(constants.APPLICATION_ROUTE.MANAGE_METRIC_TYPE_AND_DATA.ROUTE);
  }

  // Navigate to "Metrics" tab and pass selected metric type ID via query string
  gotoMetrics = data => {
    this.onContentChangeTypeHandler("metrics");
    if (data.metric_type_id) {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: "?selected_tab=metrics&metric_type_id=" + data.metric_type_id,
      });
    } else if (data.metric_unit_id) {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: "?selected_tab=metric-units&metric_unit_id=" + data.metric_unit_id,
      });
    }
  };

  render() {
    let selected = this.state.totalTabs.find(f => f.KEY === this.state.selectedTab);
    DocumentTitle(selected && selected.TAB_TITLE ? selected.TAB_TITLE : "");
    return (
      <aside className="main_content">
        <div className="m-3 mb-0 bg-white px-3 py-3 br_8 main_content_height">
          <div className="d-flex align-items-center flex-wrap title-section breadcrumb-mb-0">
            <CustomBreadcrumb breadcrumbs={this.breadcrumbs()} />
          </div>
          <div className="comapnay_tbl">
            <div className="">
              <div className="btn-items-card-wrapper tabs-card-wrapper">
                <div className="btn-items-card custom-card">
                  <div className="d-flex">
                    <Nav tabs className="metrics-custom-nav-tabs">
                      {this.state.totalTabs.map(tab => (
                        <NavItem key={tab.KEY}>
                          <NavLink
                            className={classnames({
                              active: this.state.selectedTab === tab.KEY,
                            })}
                            onClick={() => {
                              this.onContentChangeTypeHandler(tab.KEY);
                            }}
                          >
                            {tab.TAB_TITLE}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  </div>
                </div>
              </div>
              <TabContent activeTab={this.state.selectedTab}>
                {this.state.totalTabs.map(tab => (
                  <TabPane tabId={tab.KEY} key={tab.KEY}>
                    {this.state.selectedTab && this.state.selectedTab === tab.KEY && tab.KEY === "metric-types" && (
                      <ListMetricTypes
                        {...this.props}
                        selectedTab={this.state.selectedTab}
                        pageNo={constants.PAGINATION.DEFAULT_PAGE_NO}
                        pageSize={constants.PAGINATION.DEFAULT_PAGE_SIZE}
                        gotoMetrics={this.gotoMetrics}
                      />
                    )}
                    {this.state.selectedTab && this.state.selectedTab === tab.KEY && tab.KEY === "metric-units" && (
                      <ListMetricsUnit
                        {...this.props}
                        selectedTab={this.state.selectedTab}
                        pageNo={constants.PAGINATION.DEFAULT_PAGE_NO}
                        pageSize={constants.PAGINATION.DEFAULT_PAGE_SIZE}
                        gotoMetrics={this.gotoMetrics}
                      />
                    )}

                    {this.state.selectedTab && this.state.selectedTab === tab.KEY && tab.KEY === "metrics" && (
                      <ListMetrics
                        {...this.props}
                        selectedTab={this.state.selectedTab}
                        pageNo={constants.PAGINATION.DEFAULT_PAGE_NO}
                        pageSize={constants.PAGINATION.DEFAULT_PAGE_SIZE}
                        gotoMetrics={this.gotoMetrics}
                      />
                    )}
                  </TabPane>
                ))}
              </TabContent>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    activeMenuTab: tab => {
      dispatch(activeMenuTab(tab));
    },
  };
}
export default connect(null, mapDispatchToProps)(ListMetricTypesAndMetrics);
